<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الأخبار </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3"> خدمة الـ (Call-Center) على الارقام (15340 - 15341 - 16582) حتى الساعة
                            9 م </h1>

                        <p>
                            تنفيذا لتوجيهات السيد الفاضل اللواء وزير الداخليه وموافقه سيادته على تنفيذ خطه تطوير اداء
                            القطاع والارتقاء بالخدمات المقدمه لجمهور المواطنين والتيسير عليهم لمواجهه التحديات والمعوقات
                            التى تؤثر على منظومه العمل بقطاع الاحوال المدنية وبناء على توجيهات السيد اللواء مساعد الوزير
                            لقطاع الاحوال المدنية تم تنفيذ الاتى :
                            <br>
                            خدمة الـ (Call-Center) على الارقام (15340 - 15341 - 16582) حتى الساعة 9 م بـ (القاهرة –
                            الجيزة – القليوبية – الإسكندرية –الدقهلية – الغربية – أسيوط- كفر الشيخ) للحصول على الخدمات
                            الفورية (شهادة ميلاد "أول مرة" – إستمارات إستخراج البطاقات فئات"50 – 125 – 175" جنيهاً -
                            مأموريات تصوير منزلى للبطاقات) وتسليمها للمواطن بإقامته فى نفس اليوم
                        </p>


                        <img src="@/assets/images/callcenter.jpg" alt="" class="img-fluid py-3">
                    </div>

                </div>
            </div>
        </div>
    </section>


</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'News4Comp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}



</script>